import { RG_TYPE } from "@project-rouge/rg-core";
function getStartClashStatus({ action, startClosingDistance, startEntranceDistance, diff = 0, skipExistingClosingCheck = false }) {
  if (startClosingDistance > 0 && !skipExistingClosingCheck) {
    if (action.doorPosition - 0.5 * action.doorWidth + diff < startClosingDistance) {
      return false;
    }
    if (action.unit.type === RG_TYPE.Apartment && action.unit.data.closeCorridor) {
      return false;
    }
  }
  if (action.unit.type === RG_TYPE.Apartment && action.unit.data.closeCorridor) {
    if (action.unit.data.closeLength + diff > startEntranceDistance) {
      return false;
    }
  }
  return true;
}
export {
  getStartClashStatus
};
//# sourceMappingURL=index212.js.map
